export default __webpack_public_path__ + "static/ti_no_sparkle-51fd999bee3eb16de2a1c84304954a65.png";